/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Unplanned/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'



/** @type {import('Simple/types.js').View} */
export default function Unplanned({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Appointment/Content/Indicator/Past/Icon/Unplanned"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaIconWarning
  viewPath={`${viewPath}/TysiaIconWarning`}
 fill={dtColorsWhite}
 width={16}
 height={16}
/>
{children}
</React.Fragment>)
}